import { useMemo } from "react";

import { Stack } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { useClaimOptions } from "../../hooks/useClaimOptions";
import { FINANCIAL_HOLDING_KINDS } from "./AssetsView.utils";
import { CashAssetsSection } from "./components/cash-assets-section/CashAssetsSection";
import { FinancialHoldingsSection } from "./components/financial-holdings-section/FinancialHoldingsSection";
import { MovableGoodsSection } from "./components/movable-goods-section/MovableGoodsSection";
import { RealEstateSection } from "./components/real-estate-section/RealEstateSection";
import { useAssetAssets } from "./hooks/useAssetAssets";

export function AssetsView() {
  const { clientId } = useClientFileContext();
  const { formik, missingFields, onAddMove, onCancelMove } = useAssetAssets(clientId);
  const claimReferences = useMemo(
    () => formik.values.financialHoldings.map(({ encumberedClaimId }) => ({ claimId: encumberedClaimId })),
    [formik.values.financialHoldings]
  );
  const claimOptions = useClaimOptions(clientId, claimReferences);

  const documentProps = { clientId, formik, onAddMove, onCancelMove };

  return (
    <ClientContent formik={formik} missingFields={missingFields}>
      <Stack gap={2}>
        <RealEstateSection {...documentProps} />
        {FINANCIAL_HOLDING_KINDS.map((config) => (
          <FinancialHoldingsSection key={config.kind} {...documentProps} config={config} claimOptions={claimOptions} />
        ))}
        <CashAssetsSection {...documentProps} />
        <MovableGoodsSection {...documentProps} />
      </Stack>
    </ClientContent>
  );
}
